import "@css/app.css";

/* JS */
import "lazysizes";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import sal from "sal.js";

Fancybox.bind("[data-fancybox]");

// Blitz serves statically cached pages, so the CSRF token and captcha values
// baked into Formie forms are stale. Fetch fresh tokens whenever a form inits.
document.addEventListener("onFormieInit", (e) => {
  e.detail.formie.refreshForCache(e.detail.formId);
});

// Image preloading function
function preloadImages(imageUrls, callback) {
  let loadedImages = 0;
  const totalImages = imageUrls.length;

  if (totalImages === 0) {
    callback();
    return;
  }

  imageUrls.forEach((url) => {
    const img = new Image();
    img.src = url;
    img.onload = () => {
      loadedImages++;
      if (loadedImages === totalImages) {
        callback();
      }
    };
    img.onerror = () => {
      loadedImages++;
      if (loadedImages === totalImages) {
        callback();
      }
    };
  });
}

// Collect images for preloading (breadcrumbs and single images)
function collectImagesForPreloading() {
  const imagesToPreload = [];

  // Collect breadcrumb images
  const breadcrumbImgElements = document.querySelectorAll(".breadcrumbs__img");
  breadcrumbImgElements.forEach((img) => {
    if (img.src) {
      imagesToPreload.push(img.src);
    }
  });

  // Collect single images
  const singleImgElements = document.querySelectorAll(".service-image img");
  singleImgElements.forEach((img) => {
    if (img.src) {
      imagesToPreload.push(img.src);
    }
  });

  return imagesToPreload;
}

// Initialize animations after images are preloaded
function initializeAnimations() {
  sal({
    threshold: 0.1,
    once: true,
  });

  // Add loaded class to breadcrumb images
  const breadcrumbImgs = document.querySelectorAll(".breadcrumbs__img");
  breadcrumbImgs.forEach((img) => {
    img.classList.add("loaded");
  });

  // Add loaded class to single images
  const singleImgs = document.querySelectorAll(".service-image img");
  singleImgs.forEach((img) => {
    img.classList.add("loaded");
  });

  // Remove loading class
  document.body.classList.remove("js-loading");
}

// Start preloading process
document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("js-loading");

  const imagesToPreload = collectImagesForPreloading();

  preloadImages(imagesToPreload, () => {
    initializeAnimations();
  });
});

window.disableBodyScroll = disableBodyScroll;
window.enableBodyScroll = enableBodyScroll;

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);
appHeight();

window.appHeight = appHeight;

const header = document.querySelector(".site-header");

const headerHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--header-height", `${header.offsetHeight}px`);
};
window.addEventListener("resize", headerHeight);
headerHeight();

window.headerHeight = headerHeight;

var scrollLockEnabled = false;
let theNav = document.querySelector(".mobile-nav");
function shouldScrollLock() {
  if (!scrollLockEnabled) {
    disableBodyScroll(theNav);
  } else {
    enableBodyScroll(theNav);
  }
  scrollLockEnabled = !scrollLockEnabled;
}

window.shouldScrollLock = shouldScrollLock;

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import Swiper from "swiper";
import {
  Pagination,
  Navigation,
  EffectFade,
  Autoplay,
  Thumbs,
  Grid,
} from "swiper/modules";

Array.from(document.querySelectorAll(".js-slider-testimonials")).forEach(
  (container) => {
    const slider = container.querySelector(".swiper");
    const pagination = container.querySelector(".swiper-pagination");

    const swiper = new Swiper(slider, {
      modules: [Navigation, Pagination, EffectFade, Autoplay],
      loop: true,
      autoHeight: false,
      speed: 1000,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  },
);

// Utility function for debouncing
const debounce = (func, wait, immediate = false) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      if (!immediate) func(...args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(...args);
  };
};

// Performance monitoring
const performanceMonitor = {
  resizeCount: 0,
  reinitCount: 0,
  lastResizeTime: 0,

  logResize: function () {
    this.resizeCount++;
    this.lastResizeTime = Date.now();
  },

  logReinit: function () {
    this.reinitCount++;
    console.log(
      `Performance: ${this.reinitCount} reinitializations from ${this.resizeCount} resize events`,
    );
  },
};

// Manual lazy loading function
const loadImagesInSlide = (slide) => {
  if (!slide) return;

  const lazyImages = slide.querySelectorAll(".lazy-image");
  lazyImages.forEach((img) => {
    if (img.dataset.src && !img.classList.contains("loaded")) {
      // Set the src and srcset
      img.src = img.dataset.src;
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }
      if (img.dataset.sizes) {
        img.sizes = img.dataset.sizes;
      }

      // Mark as loaded
      img.classList.add("loaded");

      // Hide preloader
      const preloader = img.nextElementSibling;
      if (preloader && preloader.classList.contains("lazy-preloader")) {
        preloader.style.display = "none";
      }
    }
  });
};

// Initialize gallery with thumbnail interaction
Array.from(document.querySelectorAll(".swiper-gallery-container")).forEach(
  (container) => {
    let currentSwiperInstances = {
      thumbSwiper: null,
      parentSwiper: null,
      childSwipers: [], // Will store child swipers by index
    };

    const initializeGallery = () => {
      const parentSlider = container.querySelector(".parent-slider");
      const mobileThumbSwiper = container.querySelector(".gallery-thumbs");

      // Destroy existing swiper instances
      if (currentSwiperInstances.thumbSwiper) {
        currentSwiperInstances.thumbSwiper.destroy(true, true);
        currentSwiperInstances.thumbSwiper = null;
      }
      if (currentSwiperInstances.parentSwiper) {
        currentSwiperInstances.parentSwiper.destroy(true, true);
        currentSwiperInstances.parentSwiper = null;
      }
      // Destroy child swipers
      currentSwiperInstances.childSwipers.forEach((swiper) => {
        if (swiper) swiper.destroy(true, true);
      });
      currentSwiperInstances.childSwipers = [];

      const isMobile = window.innerWidth <= 768;

      // Function to initialize a child slider
      const initializeChildSlider = (index) => {
        if (currentSwiperInstances.childSwipers[index]) {
          return currentSwiperInstances.childSwipers[index]; // Already initialized
        }

        const childSlider = parentSlider.querySelector(
          `.swiper-slide:nth-child(${index + 1}) .child-slider`,
        );
        if (!childSlider) return null;

        const childSwiper = new Swiper(childSlider, {
          modules: [Pagination, Navigation, Thumbs],
          loop: true,
          slidesPerView: 1,
          allowTouchMove: true,
          pagination: {
            el: ".swiper-pagination-child",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            slideChange: function () {
              // Load images for the current slide
              const currentSlide = this.slides[this.activeIndex];
              loadImagesInSlide(currentSlide);
            },
            init: function () {
              // Load images for the initial slide
              const currentSlide = this.slides[this.activeIndex];
              loadImagesInSlide(currentSlide);
            },
          },
        });

        currentSwiperInstances.childSwipers[index] = childSwiper;

        // Memory management: Clean up old child sliders (keep only 3 active)
        const maxActiveSliders = 3;
        const activeSliders = Object.keys(
          currentSwiperInstances.childSwipers,
        ).filter((key) => currentSwiperInstances.childSwipers[key] !== null);

        if (activeSliders.length > maxActiveSliders) {
          // Find the oldest slider (not the current one)
          const oldestIndex = activeSliders.find(
            (sliderIndex) => parseInt(sliderIndex) !== index,
          );

          if (oldestIndex && currentSwiperInstances.childSwipers[oldestIndex]) {
            currentSwiperInstances.childSwipers[oldestIndex].destroy(
              true,
              true,
            );
            currentSwiperInstances.childSwipers[oldestIndex] = null;
          }
        }

        return childSwiper;
      };

      if (isMobile) {
        // Mobile: Initialize thumbnail swiper
        currentSwiperInstances.thumbSwiper = new Swiper(mobileThumbSwiper, {
          modules: [Navigation],
          slidesPerView: "auto",
          spaceBetween: 8,
          freeMode: false,
          watchSlidesProgress: true,
          allowTouchMove: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });

        // Mobile: Initialize parent slider
        currentSwiperInstances.parentSwiper = new Swiper(parentSlider, {
          modules: [Pagination, EffectFade],
          loop: false,
          slidesPerView: 1,
          allowTouchMove: false,
          noSwiping: true,
          effect: "fade",
          fadeEffect: { crossFade: true },
          speed: 500,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          pagination: { el: ".swiper-pagination-parent", clickable: true },
          on: {
            slideChange: function () {
              // Initialize child slider for the current slide
              const activeIndex = this.activeIndex;
              initializeChildSlider(activeIndex);
            },
            init: function () {
              // Initialize child slider for the first slide
              initializeChildSlider(0);
            },
          },
        });

        // Mobile: Add click handlers to mobile thumbnails
        const mobileThumbItems =
          mobileThumbSwiper.querySelectorAll(".thumbnail-item");
        mobileThumbItems.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            mobileThumbItems.forEach((item) => item.classList.remove("active"));
            thumbnail.classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(index);
            setTimeout(() => {
              currentSwiperInstances.parentSwiper.update();
            }, 100);
          });
        });

        // Set first mobile thumbnail as active by default
        if (mobileThumbItems.length > 0) {
          mobileThumbItems[0].classList.add("active");
        }

        // Update active thumbnail when parent slider changes
        currentSwiperInstances.parentSwiper.on("slideChange", () => {
          const activeIndex = currentSwiperInstances.parentSwiper.activeIndex;
          mobileThumbItems.forEach((item, index) => {
            item.classList.toggle("active", index === activeIndex);
          });
        });
      } else {
        // Desktop: Initialize parent slider with fade effect
        const desktopParentSlider = container.querySelector(".parent-slider");
        currentSwiperInstances.parentSwiper = new Swiper(desktopParentSlider, {
          modules: [EffectFade],
          loop: false,
          slidesPerView: 1,
          allowTouchMove: false,
          noSwiping: true,
          effect: "fade",
          fadeEffect: { crossFade: true },
          speed: 500,
          watchSlidesProgress: true,
          observer: true,
          observeParents: true,
          on: {
            slideChange: function () {
              // Initialize child slider for the current slide
              const activeIndex = this.activeIndex;
              initializeChildSlider(activeIndex);
            },
            init: function () {
              this.slideTo(0);
              // Initialize child slider for the first slide
              initializeChildSlider(0);
            },
          },
        });

        // Select only desktop thumbnails
        const desktopThumbnailItems = container.querySelectorAll(
          ".gallery-thumbs-grid .thumbnail-item",
        );

        // Add click handlers to desktop thumbnails
        desktopThumbnailItems.forEach((thumbnail, index) => {
          thumbnail.addEventListener("click", () => {
            desktopThumbnailItems.forEach((item) =>
              item.classList.remove("active"),
            );
            thumbnail.classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(index);
            setTimeout(() => {
              currentSwiperInstances.parentSwiper.update();
            }, 100);
          });
        });

        // Set first thumbnail as active by default
        if (desktopThumbnailItems.length > 0) {
          desktopThumbnailItems[0].classList.add("active");
        }

        // Update active thumbnail when parent slider changes
        currentSwiperInstances.parentSwiper.on("slideChange", () => {
          const activeIndex = currentSwiperInstances.parentSwiper.activeIndex;
          desktopThumbnailItems.forEach((item, index) => {
            item.classList.toggle("active", index === activeIndex);
          });
        });

        // Ensure first thumbnail is active after initialization
        setTimeout(() => {
          if (desktopThumbnailItems.length > 0) {
            desktopThumbnailItems.forEach((item) =>
              item.classList.remove("active"),
            );
            desktopThumbnailItems[0].classList.add("active");
            currentSwiperInstances.parentSwiper.slideTo(0);
          }
        }, 100);
      }
    };

    // Initialize on load and reinitialize on resize
    initializeGallery();

    // Improved debouncing with breakpoint detection
    let resizeTimeout;
    let isResizing = false;
    let currentBreakpoint = window.innerWidth <= 768 ? "mobile" : "desktop";
    let lastWindowWidth = window.innerWidth;

    const debouncedResize = () => {
      if (!isResizing) {
        isResizing = true;
        clearTimeout(resizeTimeout);

        performanceMonitor.logResize();

        resizeTimeout = setTimeout(() => {
          const newWindowWidth = window.innerWidth;
          const newBreakpoint = newWindowWidth <= 768 ? "mobile" : "desktop";

          // Only reinitialize if breakpoint changed or significant width change
          const widthChange = Math.abs(newWindowWidth - lastWindowWidth);
          const breakpointChanged = newBreakpoint !== currentBreakpoint;
          const significantChange = widthChange > 50; // 50px threshold

          if (breakpointChanged || significantChange) {
            console.log(
              `Resize detected: ${currentBreakpoint} -> ${newBreakpoint}, width change: ${widthChange}px`,
            );
            performanceMonitor.logReinit();
            initializeGallery();
            currentBreakpoint = newBreakpoint;
            lastWindowWidth = newWindowWidth;
          } else {
            console.log(
              `Resize ignored: width change ${widthChange}px (threshold: 50px)`,
            );
          }

          isResizing = false;
        }, 250); // Reduced debounce time for better responsiveness
      }
    };

    window.addEventListener("resize", debouncedResize);

    // Cleanup function for memory management
    const cleanup = () => {
      clearTimeout(resizeTimeout);
      window.removeEventListener("resize", debouncedResize);
    };

    // Cleanup on page unload
    window.addEventListener("beforeunload", cleanup);
  },
);

class InlineVideo {
  constructor(el) {
    this._el = el;
    this._video = el.dataset.video;
    this._image = el.querySelector(".js-video__placeholder");

    this._el.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick() {
    this._el.insertAdjacentHTML(
      "beforeend",
      `<iframe src="${this._video}?autoplay=1&rel=0" frameborder="0"></iframe>`,
    );
    this._image.classList.add("fade-out");

    setTimeout(() => {
      this._image.remove();
    }, 700);

    this._el.removeEventListener("click", this.handleClick);
  }
}

Array.from(document.querySelectorAll(".js-video")).forEach((video) => {
  new InlineVideo(video);
});

const locationDataScript = document.querySelector("#location-data");
if (locationDataScript) {
  let locationData = locationDataScript.innerHTML;
  locationData = locationData.split("|");

  const banner = document.querySelector(".banner");
  const mapContainer = document.createElement("div");
  mapContainer.classList.add("absolute", "inset-0");

  const mapDiv = document.createElement("div");
  mapDiv.id = "map";
  mapDiv.style.width = "100%";
  mapDiv.style.height = "100%";

  mapContainer.appendChild(mapDiv);
  banner.appendChild(mapContainer);

  var currentZoom = getZoomLevel();

  mapboxgl.accessToken =
    "pk.eyJ1IjoiYm9yZGVyc2RldiIsImEiOiJjbGw2Z2docWQwZ3poM2tvMDdoYW5oZHh2In0.XuqNwk39J2A9mNYPkBsT8A";
  const map = new mapboxgl.Map({
    container: "map", // container ID
    style: "mapbox://styles/bordersdev/cll6i4ru500jq01qnezkf54bz", // style URL
    center: [-98.5795, 36.828175], // starting position [lng, lat]
    zoom: currentZoom, // starting zoom
    projection: "mercator",
    interactive: false,
  });

  locationData.forEach((loc) => {
    const parts = loc.split(",");
    const el = document.createElement("div");
    el.className = "marker";
    const marker = new mapboxgl.Marker(el)
      .setLngLat([parts[0], parts[1]])
      .addTo(map);

    marker.getElement().addEventListener("click", () => {
      window.location.href = `${parts[2]}`;
    });
  });

  window.addEventListener("resize", () => {
    let newZoom = getZoomLevel();
    if (newZoom != currentZoom) {
      currentZoom = newZoom;
      map.setZoom(newZoom);
    }
  });
}

function getZoomLevel() {
  const width = window.innerWidth;
  if (width < 1024) {
    return 2.5;
  }
  return 3.75;
}

// Parallax effect functionality
document.addEventListener("DOMContentLoaded", function () {
  let elementX = 0,
    elementY = 0,
    elementW = 0,
    elementH = 0,
    mouseX = 0,
    mouseY = 0;

  document.addEventListener("mousemove", function (e) {
    const parallaxElement = document.querySelector(".parallax");
    if (!parallaxElement) return;

    const rect = parallaxElement.getBoundingClientRect();
    elementX = rect.left;
    elementY = rect.top;
    elementW = rect.width;
    elementH = rect.height;

    const halfW = elementW / 2;
    const halfH = elementH / 2;

    mouseX = (e.pageX - elementX - halfW) / halfW;
    mouseY = (e.pageY - elementY - halfH) / halfH;
    mouseX = Math.round(mouseX * 100) / 100;
    mouseY = Math.round(mouseY * 100) / 100;

    // Apply transforms to parallax elements
    const parallaxElements = document.querySelectorAll(
      ".parallax, .parallax1, .parallax2, .parallax3, .parallax4, .parallax5",
    );

    parallaxElements.forEach((element, index) => {
      let transform = "";

      if (element.classList.contains("parallax")) {
        transform = `rotateX(${mouseY * -10}deg) rotateY(${mouseX * 10}deg)`;
      } else if (element.classList.contains("parallax1")) {
        transform = `translateX(${mouseX * 0}px) translateY(${mouseY * 0}px)`;
      } else if (element.classList.contains("parallax2")) {
        transform = `translateX(${mouseX * 10}px) translateY(${mouseY * 10}px)`;
      } else if (element.classList.contains("parallax3")) {
        transform = `translateX(${mouseX * 10}px) translateY(${mouseY * 20}px)`;
      } else if (element.classList.contains("parallax4")) {
        transform = `translateX(${mouseX * 10}px) translateY(${mouseY * 40}px)`;
      } else if (element.classList.contains("parallax5")) {
        transform = `translateX(${mouseX * 50}px) translateY(${mouseY * 50}px)`;
      }

      if (transform) {
        element.style.transform = transform;
      }
    });
  });
});

/**
 * Form Cache Busting
 * Allows forms to be cached
 */
const forms = Array.from(document.querySelectorAll("form.fui-form"));
if (forms.length > 0) {
  updateForms(forms);
}

async function getCsrfToken() {
  const response = await fetch("/actions/users/session-info", {
    headers: {
      Accept: "application/json",
    },
  });
  const json = await response.json();
  return json;
}

async function updateForms(forms) {
  const token = await getCsrfToken();
  forms.map((f) => {
    const csrfInput = f.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
    csrfInput.value = token.csrfTokenValue;
  });
}
